"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminOrderPayments = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const elements_1 = require("@src/components/elements");
const streamline_icon_official_building_3_svg_1 = __importDefault(require("@public/media/icons/streamline-icon-official-building-3.svg"));
// import CreditCard from '@public/media/icons/streamline-icon-credit-card.svg'
const types_1 = require("@src/types");
// import { Checkout } from '@src/components/modules/global/Checkout'
const OfferNotificationSubscriptionModal_1 = require("@src/components/pages/offers/modules/OfferNotificationSubscriptionModal");
const react_intl_1 = require("react-intl");
const antd_1 = require("antd");
const Api = __importStar(require("@src/api"));
const react_router_1 = require("react-router");
const react_query_1 = require("react-query");
const queries_1 = require("@src/types/queries");
const AdminOrderPayments = ({ selectedBillingProfile, isOrderLoading, appliedCouponCode, setIsOrderLoading, orderContent, orderParams, offerId, onOrderSuccess, companyPaymentMethodToken, }) => {
    const history = (0, react_router_1.useHistory)();
    const intl = (0, react_intl_1.useIntl)();
    const queryClient = (0, react_query_1.useQueryClient)();
    const [paymentMethod, setPaymentMethod] = react_1.default.useState(types_1.PaymentMethod.bank_transfer);
    const paymentOptionsBoxes = [
        // Temporarily disabled: card payment option.
        // {
        // 	icon: <CreditCard />,
        // 	label: intl.formatMessage({
        // 		id: 'global.checkout.pay_by_card',
        // 	}),
        // 	value: PaymentMethod.credit_card,
        // },
        {
            icon: (0, jsx_runtime_1.jsx)(streamline_icon_official_building_3_svg_1.default, {}),
            label: intl.formatMessage({
                id: 'global.checkout.pay_by_bank_transfer',
            }),
            value: types_1.PaymentMethod.bank_transfer,
        },
    ];
    const bankTransferDescriptionsConfig = {
        [types_1.ProductType.promotion]: intl.formatMessage({
            id: 'admin.payments.create_order_info.offer_promotion',
        }),
        [types_1.ProductType.credit]: intl.formatMessage({
            id: 'admin.payments.create_order_info.credits',
        }),
        [types_1.ProductType.subscription]: intl.formatMessage({
            id: 'admin.payments.create_order_info.subscription',
        }),
    };
    const bankTransferDescription = (orderContent === null || orderContent === void 0 ? void 0 : orderContent.orderType)
        ? bankTransferDescriptionsConfig[orderContent === null || orderContent === void 0 ? void 0 : orderContent.orderType]
        : '';
    const createInvoiceAndOrder = async () => {
        var _a;
        try {
            if (!orderContent) {
                throw new Error(intl.formatMessage({
                    id: 'admin.order.invalid_order',
                }));
            }
            setIsOrderLoading(true);
            let invoiceId = null;
            const invoice = await Api.Invoice.createInvoice({
                isProforma: true,
                orderContent,
                orderParams,
                couponCode: appliedCouponCode,
                billingProfileId: selectedBillingProfile === null || selectedBillingProfile === void 0 ? void 0 : selectedBillingProfile.id,
                offerId,
            });
            invoiceId = invoice.id || null;
            setIsOrderLoading(false);
            if (onOrderSuccess && invoiceId) {
                onOrderSuccess(types_1.PaymentMethod.bank_transfer, invoiceId);
            }
            if (!onOrderSuccess) {
                history.pushLocalized(`/admin/objednavka/platobne-informacie/${invoiceId}`);
            }
            queryClient.invalidateQueries(queries_1.Queries.getCompany);
        }
        catch (err) {
            setIsOrderLoading(false);
            // eslint-disable-next-line no-console
            console.error(err);
            const errDescription = ((_a = err.response) === null || _a === void 0 ? void 0 : _a.status) === 422
                ? intl.formatMessage({
                    id: 'global.checkout.invalid_payment_information',
                })
                : intl.formatMessage({
                    id: 'general.something_went_wrong',
                });
            antd_1.notification.error({
                message: intl.formatMessage({
                    id: 'global.notification_variants.error',
                }),
                description: errDescription,
            });
        }
    };
    return ((0, jsx_runtime_1.jsxs)(elements_1.Panel, { className: "m-t-m", children: [(0, jsx_runtime_1.jsx)("div", { className: "flex-center m-b-m", children: (0, jsx_runtime_1.jsx)(elements_1.RadioGroupBox, { size: "large", boxes: paymentOptionsBoxes, onChange: e => setPaymentMethod(e.target.value), value: paymentMethod }) }), paymentMethod === types_1.PaymentMethod.bank_transfer && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(OfferNotificationSubscriptionModal_1.StyledInfoAlert, { type: "info", showIcon: true, message: intl.formatMessage({
                            id: 'admin.payments.create_order_info.notes',
                        }), description: bankTransferDescription }), (0, jsx_runtime_1.jsx)("div", { className: "flex-center m-t-l", children: (0, jsx_runtime_1.jsx)(elements_1.Button, { type: "primary", loading: isOrderLoading, onClick: createInvoiceAndOrder, children: (0, jsx_runtime_1.jsx)("span", { className: "m-r-xxs", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "global.checkout.create_order" }) }) }) })] }))] }));
};
exports.AdminOrderPayments = AdminOrderPayments;
